export const portalRoutes = {
  dashboard: '/',
  login: '/login',
  register: '/registrieren',
  passwordResetRequest: '/passwort-vergessen',
  passwordResetConfirm: '/passwort-zuruecksetzen/demo-token',
  configurator: '/configurator',
  uploads: '/uploads',
  credits: '/credits',
  orders: '/orders',
  orderDetail: '/orders/TFD-24001',
  priceList: '/price-list',
  invoices: '/invoices',
  tickets: '/tickets',
  ticketDetail: '/tickets/TIC-1001',
  newOrder: '/new-order',
  orderLive: '/order-live',
  emailTemplates: '/email-templates',
  dtcCodes: '/dtc-codes',
  statistics: '/statistics',
  order: '/auftrag',
  profile: '/profil',
  vehicles: '/fahrzeuge',
  logout: '/logout',
};
